
<template>

    <div>

        <div class="order-tab">

            <div class="order-tab-top-section">

                <div class="merchant-header-wrap">

                    <p class="merchant-name">{{ currentMerchant.name }}</p>
                    <p class="merchant-location">{{ currentLocation.name }}</p>
                </div>
                <div class="order-outer-wrapper">

                    <p class="order-title">Your Order: <span @click=" clearTab() ">Remove All</span></p>
                    <ul class="order-list">

                        <li :class=" tabItemClasses( item ) " v-for=" ( item, key ) in currentTab " :key=" key ">

                            <div class="item-quantity">

                                <p v-if=" itemValid( item ) ">{{ item.quantity + 'x' }}</p>
                                <font-awesome-icon v-else style=" color: red " icon="exclamation-triangle" />
                            </div>
                            <div class="item-details">

                                <p class="item-name">{{ item.name }}</p>
                                <p v-if=" item.reason " class="unavailable-reason">{{ item.reason }}</p>
                                <p :class=" modifierTitleClasses( mod ) " v-if=" item.available != 0 " v-for=" ( mod, modKey ) in item.modifiers" :key=" modKey " >{{ mod.split( "_" )[ 5 ] }}</p>
                                <p v-if=" item.available != 0" class="edit-button" @click=" initEditItem( item ) ">Edit</p>
                            </div>
                            <div class="item-price">

                                <span>{{ '$' + item.price }}</span>
                                <p class="remove-button" @click=" removeItem( item ) ">Remove</p>
                            </div>
                        </li>
                        <li class="order-note">

                            <textarea maxlength="50" rows="3" columns="50" placeholder="Add Note ( extra napkins, extra sauce... )" v-model=" orderNoteValue "></textarea><!-- @blur=" updateNote( $event.target.value ) "-->
                        </li>
                    </ul>
                </div>
            </div>
            <div class="order-tab-bottom-section">

                <div class="delivery-wrapper" v-if=" deliverySelected.deliveryType == 'PickupCounter' && currentLocation.pickupCounter !== false">

                    <h4>Pickup Selected</h4>

                    <div class="order-subtotal-wrapper">

                        <p class="order-subtotal-number"> In-Store Pickup </p>
                        <p class="edit-delivery-button" @click=" initEditDelivery() ">Edit</p>
                    </div>

                </div>

                <div class="delivery-wrapper" v-if=" deliverySelected.deliveryType == 'FullDelivery' && currentLocation.fullDelivery !== false">
                    <div class="order-subtotal-wrapper">
                        <h4>Deliver to:</h4>
                        <p class="order-subtotal-number-less-top" >{{ deliverySelected.addressOne }} {{ deliverySelected.addressTwo }} <br>{{ deliverySelected.addressCity }}, {{ deliverySelected.addressState }}  {{ deliverySelected.addressZip }}</p>

                        <h4 v-if="deliverySelected.deliveryInstructions != ''">Instructions:</h4>
                        <p class="order-subtotal-number-less-top">{{ deliverySelected.deliveryInstructions }}</p>

                        <p class="edit-delivery-button" @click=" initEditDelivery() ">Edit</p>
                    </div>
                </div>

                <div class="delivery-wrapper" v-if=" deliverySelected.deliveryType == 'PickupSpot' && currentLocation.pickupSpot !== false">

                    <h4>Pickup Spot Selected</h4>

                    <div class="order-subtotal-wrapper">

                        <p class="order-subtotal-number">{{ deliverySelected.displayName }}, <br> {{ deliverySelected.description }}</p>
                        <p class="edit-delivery-button" @click=" initEditDelivery() ">Edit</p>
                    </div>

                </div>
                <div class="delivery-wrapper" v-if=" deliverySelected.deliveryType == 'BuildingDelivery' && currentLocation.buildingDelivery !== false">

                    <h4>Delivery Selected to {{ currentLocation.merchantId == merchantIdCrocante ? 'Table #' : 'In-Mall' }}</h4>

                    <div class="order-subtotal-wrapper">

                        <p class="order-subtotal-number">{{ deliverySelected.detailBuilding }}</p>
                        <p class="edit-delivery-button" @click=" initEditDelivery() ">Edit</p>
                    </div>

                </div>

                <TipWidget v-if="verifyTip" />

                <div class="order-infocards-wrapper" v-if="isAuth && !showBonusCard && filteredCardsByMerchant.length != 0 && currentTab.length > 0">
                    <p>No bonus card applied</p>
                    <button @click=" showPromotionCards() " >Select Bonus Card</button>
                </div>

                <div :class=" OrderFeesWrapperClass ">
                    <div class="order-infocards-wrapper text-success" v-if="showBonusCard && currentTab.length > 0">
                        <p >Bonus Cards Applied</p>
                        <button @click=" showPromotionCards() " >Edit Bonus Card</button>
                    </div>
                    <div class="order-subtotal-wrapper">
                            <p class="order-subtotal-title">Subtotal</p>
                            <p class="order-subtotal-number">${{ totalTicketAmount.toFixed( 2 ) }}</p>
                    </div>
                    <div class="promotion-cards text-danger" v-if="showBonusCard">
                        <p>{{ currentCard.PrepaidCampaign.name }}</p>
                        <p class="order-subtotal-number text-danger">- ${{ amountBonusCard }}</p>
                    </div>
                    <div class="order-subtotal-wrapper" v-if="showBonusCard">
                        <p class="order-subtotal-title">Subtotal After Discount</p>
                        <p class="order-subtotal-number">${{ parseFloat(subTotalAfter, 0.00).toFixed(2) }}</p>
                    </div>
                    <div class="order-tip-wrapper" v-if=" orderTip != 0.00 ">

                        <p class="order-tip-title">Tip</p>
                        <p class="order-tip-number">${{ orderTip }}</p>
                    </div>
                    <div class="order-delivery-fee-wrapper" v-if=" deliverySelected.deliveryType == 'FullDelivery' && currentLocation.fullDelivery !== false">

                        <p class="order-delivery-fee-title">Priority Delivery Fee <font-awesome-icon class="info-icon" icon="info" @click=" openModalInfo('delivery') " /></p>
                        <p class="order-delivery-fee-number">{{ ((getDeliveryFee).toFixed( 2 ) == '0.00') ? '' : '$' }} {{ ((getDeliveryFee).toFixed( 2 ) == '0.00') ? 'Free' : (getDeliveryFee).toFixed( 2 )  }}</p>
                    </div>
                    <div class="order-tax-wrapper" v-if=" deliverySelected.deliveryType == 'FullDelivery' && currentLocation.fullDelivery !== false">

                        <p class="order-tax-title">Taxes & other fees <font-awesome-icon class="info-icon" icon="info" @click=" openModalInfo('taxes') " /></p>
                        <p class="order-tax-number">${{ updateTaxValue().toFixed( 2 ) }}</p>
                    </div>
                    <div class="order-tax-wrapper" v-else>
                        <p class="order-tax-title">Estimated Tax</p>
                        <p class="order-tax-number">${{ getTax }}</p>
                    </div>
                    <div class="order-total-wrapper">

                        <p class="order-total-title">Total</p>
                        <p class="order-total-number">${{ orderTotal }}</p>
                    </div>
                </div>

                <div class="checkout-tab" >

                    <button :class=" CheckoutButtonClass " @click=" goToLogin() " v-if="!isAuth" >

                        Checkout
                    </button>

                    <button :class=" PayCreditCardOnFileButtonClass " @click=" cardOnFile() " v-else-if="isAuth && (hasCardOnFile && verifyIfShowForm) && (getPayWithCreditCardValue == true)">

                        Pay with Credit Card on File
                    </button>

                    <button :class=" CheckoutButtonWithOptiomClass " @click=" newCreditCard() " :disabled=" currentTab.length < 1 || invalidItemsExist " v-else-if="isAuth && (getPayWithCreditCardValue == true)" >

                        Checkout
                    </button>

                    <p class="add-credit-card" @click=" newCreditCard() " v-if="isAuth && (hasCardOnFile && verifyIfShowForm) && (getPayWithCreditCardValue == true)">Pay with different Credit Card</p>

                    <button :class=" relevantClasses " @click=" payAtStore() " v-if="isAuth && (getPayOnPickupValue == true)" :disabled=" isLoadingOrder ">

                        <font-awesome-icon class="lock-icon" v-if=" !isLoadingOrder " icon="lock-open"/>
                        <font-awesome-icon class="lock-icon" v-else icon="lock"/>
                        Pay At Store
                    </button>
                    
                </div>

            </div>

        </div>

        <div :class=" modalInfoClasses ">
            <div class="close-icon" >
                <button type="button" class="close-modal-info" @click=" closeModalInfo() " >X</button>
            </div>
            <p class="title-name">{{ modalInfoTitle }}</p>
            <hr/>
            <p>{{ modalInfoDescription }}</p>
        </div>

    </div>
</template>

<script>

    import { mapState, mapGetters, mapActions } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';
    import OrderError from '../misc/OrderError';
    import TipWidget from '../misc/TipWidget';

    export default {

        name: 'order-tab',
        data: function(){

            return {
                amountBonusCard:null,
                total:0,
                deliveryFee:0,
                otherFeesAmount:0,
                openModalInfoTaxesAndOtherFees:false,
                openModalInfoPriorityDeliveryFees:false,
                modalInfoTitle:'',
                modalInfoDescription:''
            }
        },
        methods: {

            ...mapActions({

                removeItem  : 'orderTab/removeItem',
                clearTab    : 'orderTab/clearTab',
            }),
            updateTaxValue(){
                console.log('updating Taxes value with other fees amount')
                return parseFloat(this.getTax) + parseFloat(this.getDeliveryOtherFee)
            },
            openModalInfo(type){
                switch (type) {
                    case 'taxes':
                        this.openModalInfoTaxesAndOtherFees = true
                        this.openModalInfoPriorityDeliveryFees = false
                        this.modalInfoTitle = 'Taxes & Other Fees'
                        this.modalInfoDescription = 'Taxes & Other Fees include applicable taxes and order processing fees.'
                        break;

                    case 'delivery':
                        this.openModalInfoPriorityDeliveryFees = true
                        this.openModalInfoTaxesAndOtherFees = false
                        this.modalInfoTitle = 'Priority Delivery Fees'
                        this.modalInfoDescription = 'Delivery fees include access to the driver network, fuel surcharges and prioritizing your order based on time-of-day network demand.'
                        break;
                
                    default:
                        break
                }
            },
            closeModalInfo(){
                this.openModalInfoTaxesAndOtherFees = false
                this.openModalInfoPriorityDeliveryFees = false
            },
            goToLogin(){
                this.$router.push({

                    name: 'signin',
                    params : { slug : this.merchantSlug }
                });
            },
            payAtStore(){

                const data = {

                    encryptedData  : null,
                    saveCard : false,
                    useCard : false,
                    delivery : this.deliverySelected,
                    bonus: null,
                    subTotalBefore: parseFloat(this.totalTicketAmount).toFixed(2),
                    subTotalAfter: this.subTotalAfter,
                    payOnPickup: this.getPayOnPickupValue
                };

                console.log('Submit New Order Without Payments...');
                this.$store.dispatch( 'orderTab/submitOrder', data );
            },
            tabItemClasses( item ){

                const base = [ 'order-item' ];
                base.push( item.available == 0 ? 'unavailable-item' : '' );
                base.push( this.hasUnavailableModifiers( item ) ? 'unavailable-modifiers' : '' );
                return base.join( ' ' );
            },
            hasUnavailableModifiers( item ){

                for( var i = 0; i < item.modifiers.length; i++ ){

                    const modArray = item.modifiers[ i ].split( '_' );
                    if( modArray[ modArray.length - 1 ] == 'unavailable' ){

                        item.modsValid = 0;
                        item.reason = 'modifier(s) unavailable';
                        return true;
                        break;
                    }
                }
                return false;
            },
            itemValid( item ){

                if( item.available == 0 ) return false;
                else return !this.hasUnavailableModifiers( item );
            },
            modifierTitleClasses( mod ){

                const base = [ 'item-modifier' ];
                const modArray = mod.split( '_' );
                base.push( modArray[ modArray.length - 1 ] == 'unavailable' ? 'strikethrough' : '' );
                return base.join( ' ' );
            },
            initEditItem( item ){

                this.$emit( 'toggleTab' );
                this.$router.push({

                    name : 'order-menu',
                    params : { slug : this.merchantSlug }
                });
                this.$store.dispatch( 'orderMenu/chooseItem', item )
                    .then( () => {

                        setTimeout( () => {

                            this.$store.dispatch( 'orderMenu/editItem', item );
                        }, 500 );
                })
            },
            initEditDelivery(){

                this.$router.replace({
                    name: 'merchant-delivery'
                });
            },
            newCreditCard(){
                this.$router.push({

                    name: 'payment',
                    params : { slug : this.merchantSlug }
                });
            },
            cardOnFile(){

                if( parseInt( this.currentLocation.acceptingOrders ) == 0 ){

                } else {
                    this.$router.push({

                        name: 'payment-card',
                        params : { slug : this.merchantSlug }
                    });
                }
            },
            showPromotionCards() {
                this.$store.dispatch('cards/cleanCardsWithoutCurrent');
                this.$router.push({
                    name: 'order-promotion-card',
                    params : { slug : this.merchantSlug }
                });
            },
            toggleSaveCard(){
                this.$store.dispatch( 'orderTab/toggleSaveCard' );
            },
            updateNote( value ){

                const sanitized = String( value ).replace(/([-()\[\]{}+?*.$\^|:#<!\\])/g, '').
                    replace(/\x08/g, '\\x08');
                this.$store.dispatch( 'orderTab/updateNote', sanitized );
            }
        },
        computed: {

            ...mapState({

                currentTab       : state => state.orderTab.currentTab,
                previousMenuView : state => state.orderMenu.previousMenuView,
                selectedCategory : state => state.orderMenu.selectedCategory
            }),
            ...mapGetters({

                totalTicketAmount         : 'orderTab/getCost',
                getTax                    : 'orderTab/getTax',
                orderNote                 : 'orderTab/orderNote',
                getDeliveryFee            : 'orderTab/getDeliveryFee',
                getDeliveryOtherFee       : 'orderTab/getDeliveryOtherFee',
                getValueDeliveryFee       : 'merchant/getValueDeliveryFee',
                currentMerchant           : 'merchant/currentMerchant',
                currentLocation           : 'merchant/currentLocation',
                merchantSlug              : 'merchant/merchantSlug',
                deliverySelected          : 'merchant/deliverySelected',
                profileInfo               : 'auth/profileInfo',
                orderTotal                : 'orderTab/orderTotal',
                saveCard                  : 'orderTab/saveCard',
                hasCardOnFile             : 'cards/hasCardOnFile',
                orderError                : 'orderTab/orderError',
                wallet                    : 'cards/wallet',
                currentCard               : 'cards/currentCard',
                subTotalAfter             : 'orderTab/getCostAfterBonusCard',
                filteredCardsByMerchant   : 'cards/filteredCardsByMerchant',
                isAuth                    : 'auth/isAuth',
                getPayOnPickupValue       : 'merchant/getPayOnPickupValue',
                getPayWithCreditCardValue : 'merchant/getPayWithCreditCardValue',
                isLoadingOrder            : 'orderTab/isLoadingOrder',
                merchantIdCrocante        : 'merchantIdCrocante',
            }),
            modalInfoClasses: function(){

                const base = [ 'tab-bar' ];
                base.push( ( this.openModalInfoPriorityDeliveryFees || this.openModalInfoTaxesAndOtherFees ) ? 'tab-bar-opened' : 'tab-bar-closed' );

                return base.join( ' ' );
            },
            verifyIfShowForm(){
                console.log(this.subTotalAfter);
                if ( this.subTotalAfter > 0 || this.deliveryFee > 0 ) {
                    return true;
                } else {
                    this.$store.commit( 'orderTab/updateTip', 0 );
                    return false;
                }
            },
            verifyTip(){
                //console.log("im tip");
                if ( this.subTotalAfter > 0 || this.deliveryFee > 0 ) {
                    return true;
                } else {
                    this.$store.commit( 'orderTab/updateTip', 0 );
                    return false;
                }
            },
            showBonusCard( state ){
                let currentMerchant = this.$store.getters['merchant/currentMerchant'];
                let currentCard = this.$store.getters['cards/currentCard'];
                let cost = this.$store.getters['orderTab/getCost'];
                console.log("the cost es: ",cost);
                if ( currentCard != null ) {
                    if ( currentCard.Merchant.merchantId == currentMerchant.merchantId ) {
                        if ( currentCard.PrepaidAccount.balance >= cost ) {
                            this.amountBonusCard = cost;
                        } else {
                            this.amountBonusCard = currentCard.PrepaidAccount.balance;
                        }
                        return true;
                    }
                    return false;
                }
                return false;
            },
            invalidItemsExist(){

                let exists = false;
                this.currentTab.forEach( tabItem => {

                    for( var i = 0; i < tabItem.modifiers.length; i++ ){

                        const modArray = tabItem.modifiers[ i ].split( '_' );
                        if( modArray[ modArray.length - 1 ] == 'unavailable' ){

                            //console.log( 'getting here..' );
                            exists = true;
                            break;
                        }
                    }
                });
                return exists;
            },
            orderNoteValue: {
                get(){

                    console.log('orderNoteValue....')
                    const noteNull = JSON.parse( localStorage.getItem( 'updateNote' ) )
                    console.log(noteNull)

                    if ( noteNull == null) {
                        console.log('orderNoteValue NULL....')
                        return ''
                    }

                    return this.$store.getters[ 'orderTab/orderNote' ];
                },
                set( value ){

                    this.$store.dispatch( 'orderTab/updateNote', value );
                }
            },
            orderTip: {

                get(){

                    return this.$store.getters[ 'orderTab/orderTip' ];
                },
                set( value ){

                    this.$store.commit( 'orderTab/updateTip', value );
                    this.$store.commit( 'orderTab/setTipValue', value);
                }
            },
            paymentApiItems: function() {

                const items = [];
                items.push({

                    label : 'subtotal',
                    amount: {

                        currency : 'USD',
                        value    : this.totalTicketAmount.toFixed( 2 )
                    }
                });
                items.push({

                    label : 'tax',
                    amount: {

                        currency : 'USD',
                        value    : this.getTax.toFixed( 2 )
                    }
                });
                items.push({

                    label : 'tip',
                    amount: {

                        currency : 'USD',
                        value    : this.orderTip
                    }
                });
                return items;
            },
            relevantClasses(){

                const base = [ 'button' ];
                base.push( ( !this.isLoadingOrder ) ? 'btn-green' : '' );
                base.push( ( !this.isLoadingOrder ) ? 'pay-at-store-margin' : '' );

                return base.join( ' ' );
            },
            OrderFeesWrapperClass(){
                const base = [ 'order-fees-wrapper' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'crocante-color' : 'xo-color' )
                return base.join( ' ' );
            },
            CheckoutButtonClass(){

                const base = [ 'button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'btn-brown' : 'btn-blue' )
                return base.join( ' ' );
            },
            CheckoutButtonWithOptiomClass(){

                const base = [ 'button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'btn-brown mt-5' : 'btn-blue mt-5' )
                return base.join( ' ' );
            },
            PayCreditCardOnFileButtonClass(){

                const base = [ 'button' ];
                base.push( this.currentLocation.merchantId == this.merchantIdCrocante ? 'btn-brown' : 'btn-green' )
                return base.join( ' ' );
            },
            environment(){

                return process.env.VUE_APP_ENVIRONMENT
            }
        },
        components: {

            TipWidget,
            FontAwesomeIcon,
            OrderError
        },
        created(){

            if (this.isAuth) {
                this.$store.commit('cards/clearCofLocally');
                console.log( 'getting all cards.' );
                this.$store.commit('orderTab/orderError', null);
                this.$store.dispatch( 'cards/cleanCardsWithoutCurrent' );
                this.$store.dispatch( 'cards/getCards' );
                this.$store.dispatch( 'cards/getPaymentOptions' );
            } else {
                this.$store.dispatch( 'cards/cleanCardsForDelivery' );
            }

            console.log('inside the created...');
            //console.log(this.orderTotal);
            if ( this.deliverySelected.deliveryType == 'FullDelivery' && this.currentLocation.fullDelivery !== false ) {
                this.$store.dispatch( 'orderTab/getOrderFees' ).then( otherFees => {
                    console.log('getOrderFees...')
                });
            }
            console.log('inside the created activeOrder...');
            //this.deliveryFee = JSON.parse( localStorage.getItem( 'activeOrder' ) ).deliveryFee;
        }
    }
</script>

<style scoped>

    .order-tab {

        display: flex;
        flex-direction: column;
        justify-content: space-between;

        height: 100%;
    }

    .merchant-header-wrap {

        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 105px;
    }
    .merchant-name {

        font-size: 1.6rem;
        font-weight: bold;
        margin: 0 0 5px;
    }
    .merchant-location {

        font-size: 1rem;
        font-weight: bold;
        margin: 0;
    }

    .order-outer-wrapper {

        box-sizing: border-box;
        padding: 0 15px;
    }
    .order-title {

        margin: 0;
        font-weight: bolder;
        color: #444444;
        display: flex;
        justify-content: space-between;
    }
        .order-title > span {

            color: rgb( 173, 8, 8 );
            cursor: pointer;
        }
    .order-list {

        list-style: none;
        margin: 10px 0; padding: 0;
        width: 100%;
        min-height: 140px;
    }
    .order-item {

        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 25px 0px;
        color: #333;
        border-bottom: 1px solid #ccc;
    }
    .unavailable-item > .item-price > span {

        text-decoration: line-through;
    }
    .unavailable-reason {

        color: rgb( 173, 8, 8 ) !important;
    }
    .strikethrough {

        text-decoration: line-through;
        color: #d88c00 !important;
    }
    .item-quantity {

        flex: 1;
        align-self: center;
        color: green;
    }
    .item-details {

        flex: 8;
    }
        .item-name {

            margin: 0;
            font-size: 1.1rem;
            font-weight: 600;
        }
        .item-modifier {

            margin: 0;
            color: #777;
        }
    .item-price {

        flex: 1;
        align-self: center;
        text-align: center;
    }

    .order-note {

        padding: 8px 0px;
        font-size: 0.9rem;
        font-weight: bold;
        color: #777;
    }
    .order-note > textarea {

        width: 100%;
        margin: 0px 1px;
    }

    .edit-button {

        margin: 0;
        width: 35px;
        color: rgb( 21, 66, 198 );
        cursor: pointer;
    }
    .remove-button {

        margin: 0;
        color: rgb( 173, 8, 8 );
        cursor: pointer;
    }

    .order-fees-wrapper {

        padding: 0px 15px;
    }
    .order-fees-wrapper > div {

        display: flex;
        justify-content: space-between;
    }
    .order-fees-wrapper > div > p {

        margin: 5px 0;
    }
    .order-fees-wrapper > div > p:first-child {

    }
    /* .order-fees-wrapper > div > p:nth-child( 2 ) {

        color: green;
    } */

    .xo-color > div > p:nth-child( 2 ) {

        color: green;
    }

    .crocante-color > div > p:nth-child( 2 ) {

        color: #4A2612;
    }

    .order-total-wrapper {

        border-top: 1px solid #ccc;
        height: 40px;
        margin-top: 5px;
        box-sizing: border-box;
        font-weight: bold;
        font-size: 17px;
    }

    .pay-at-store-margin {
        margin-top: 5px;
    }


    .no-card {

        font-weight: bold;
        color: red;
    }
    .order-payment-wrapper {

        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        height: 52px;
    }
    .order-payment-details > img {

        width: 35px;
        height: 21px;
    }

    .order-payment-details {

        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .card-details {

        padding-left: 15px;
        font-weight: bold;
        margin: 0;
    }

    .save-card {

        display: flex;
        align-items: center;
        justify-content: flex-end;
        font-weight: bold;
        height: 100%;
    }

    .add-credit-card {
        align-self: center;
        text-align: center;
        padding: 10px 10px;
        height: 50%;
    }

    .save-card > input {

        height: 25px;
        width: 35px;
    }

    .checkout-tab {

        margin-top: 10px;
        position: relative;
    }
    .checkout-tab > button {

        width: 100%;
        height: 50px;
        font-size: 18px;
        padding: 0;
    }

    .delivery-wrapper{

        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        text-align: center;
        margin: 0;
    }
    .delivery-wrapper > h4 {

        margin: 0;
    }
    .edit-delivery-button {

        margin: 10px;
        margin-top: 30px;
        color: rgb( 21, 66, 198 );
        cursor: pointer;
    }
    .order-infocards-wrapper {
        display:flex;
        justify-content: space-between;
        padding:15px 10px;
    }
    .order-infocards-wrapper button {
        color:white;
        background: #4d9af7;
        border-radius: 2px;
        border:none;
        padding:7px 10px;
        font-size:.9em;
    }
    .text-danger{
        color:red!important;
    }
    .promotion-cards{
        text-align:right;
    }
    .text-success{
        color:green;
    }

    .order-tab-bottom-section{
        margin-bottom: 100px;
    }

    .order-subtotal-number-less-top{
        margin-top: -20px;
    }
    .info-icon {
        cursor: pointer;
        width: 25px;
        color: #36393E;
    }
    .tab-bar {
        background-color: white;
        color: #36393E;
        width: 100%;
        height: 300px;
        box-sizing: border-box;
        position: fixed;
        z-index: 250;
        padding: 10px 25px;
        left: 0;
        right: 0;
        transition: bottom 0.3s ease-in;
        bottom: 0px;
    }
    .tab-bar-opened {

        bottom: 65px;
    }
    .tab-bar-closed {

        bottom: -250px;
    }
    .merchant-info-wrap {

        display: flex;
        background-color: white;
        color: black;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        height: 105px;
        z-index: 250;
    }
    .close-modal-info {
        border: none;
        font-size: 20px;
        margin-left: 25px;
        cursor: pointer;
        font-weight: bold;
        color: #1a1b1b;
        background: transparent;
    }
    .title-name {
        font-size: 1.0rem;
        font-weight: bold;
        margin: 0 0 5px;
    }
    .close-icon {
      margin-left: 75%;
      position:fixed;
      right: 20px;
    }
</style>
